import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../_services";
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from "rxjs";
import { AstrolyticsService } from "../../_services/astrolytics.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  userExists;
  user;
  selectedStore;

  protected feedback = {
    name: "",
    email: "",
    text: ""
  }

  subscription: Subscription

  constructor(private auth: AuthenticationService, private astrolyticsService: AstrolyticsService, private router: Router) {
    this.userExists = auth.isAuth();
    this.user = auth.currentUserValue;
    this.selectedStore = auth.selectedStoreValue;
    this.subscription = auth.currentUser.subscribe(message => {
      this.user = auth.currentUserValue;
      this.userExists = auth.isAuth();
      this.selectedStore = auth.selectedStoreValue;
    });
  }

  logout() {
    this.auth.logout();
    this.router.navigate(["/login"]);
  }

  selectStore(storeName) {
    this.auth.changeSelectedStore(storeName);
    this.selectedStore = null;
    this.selectedStore = this.auth.selectedStoreValue;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    let element: any = $('[data-toggle="tooltip"]')
    element.tooltip()
  }

  submitFeedback() {
    console.log(this.feedback);
    this.astrolyticsService.sendFeedback(this.feedback)
  }

  showSidebar(e) {
    e.preventDefault();
    $("#sidebar-wrapper").toggleClass("sidebar-toggled");
  }

}
